import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from 'Core/components/Layout';
import { getAppConfig } from 'Core/config/appConfig';
import logoEasyCredit from 'Images/powered_by_easy_credit.svg';
import logoHearCom from 'Images/logo_hearcom_payment-portal.svg';
import logoAudibene from 'Images/logo-de.svg';

const logos = {
  us: logoHearCom,
  ca: logoHearCom,
  de: logoAudibene,
  nl: logoAudibene,
  fr: logoAudibene,
};
const easyCreditLink = {
  us: 'https://www.easycredit.de/',
  ca: 'https://www.easycredit.de/',
  de: 'https://www.easycredit.de/',
  nl: 'https://www.easycredit.de/',
  fr: 'https://www.easycredit.de/',
};

const HeaderBanner = () => {
  const { t } = useTranslation();
  const { country } = getAppConfig();

  return (
    <Container className="!mb-0 mt-0">
      <div className="!items-center flex flex-nowrap justify-between gap-2 md:gap-4">
        <div className="flex-shrink-0">
          <img 
            src={logos[country]} 
            alt="Payment Portal Logo" 
            className="h-5 md:h-8 lg:h-[35px] w-auto"
          />
        </div>
        <div className="flex-1 !text-center px-1 md:px-2">
          <h1 className="text-sm md:text-xl lg:text-2xl">{t('easyCredit.website-claim')}</h1>
        </div>
        <div className="flex-shrink-0 !flex !justify-end">
          <a href={easyCreditLink[country]} target="_blank" rel="noreferrer">
            <img 
              src={logoEasyCredit} 
              alt="powered by easy credit" 
              className="h-12 md:h-20 lg:h-[5rem] w-auto"
            />
          </a>
        </div>
      </div>
    </Container>
  );
};

export default HeaderBanner;
